/**
 * @typedef PartialShipFrom
 * @property {string} shipFromId
 * @property {boolean} isDefault
 */

/**
 * if a value already exists use that value,
 * otherwise use the default ship from,
 * if there is no default just use the first
 * if no shipFroms will return undefined
 * @param {string?} shipFromId
 * @param {PartialShipFrom[]} sellerShipFroms
 * @returns {string?}
 */
export const getShipFromIdOrDefault = (shipFromId, sellerShipFroms) => {
  if (shipFromId) {
    return shipFromId;
  }
  const defaultShipFrom = sellerShipFroms.find((shipFrom) => shipFrom.isDefault);
  if (defaultShipFrom) {
    return defaultShipFrom.shipFromId;
  }
  return sellerShipFroms[0]?.shipFromId;
};
